class EditSimulationDataInstancesController {
    constructor() {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.rufUrl = `RUF/user/manage/${this.testerId}/simulation-data/${this.simulatorId}?embed=true&modal=true`;
        };
        this.cancel = () => {
            this.dismiss();
        };
    }
}
angular.module('app').component('editSimulationDataInstances', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&',
        testerId: '<',
        simulatorId: '<'
    },
    templateUrl: 'scripts/app/partials/SimulationData/user/edit-simulation-data-instances.tpl.html',
    controllerAs: 'vm',
    controller: EditSimulationDataInstancesController
});
